/**
 * App Routes
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars-2';

// Components
import SidebarContent from 'Components/Sidebar';
import FieldSidebar from 'Components/FieldSidebar';
import Header from 'Components/Header/Header';
import LoadingView from 'Components/common/LoadingView';

import { checkPermission } from 'Util/Permissions';

// actions
import { collapsedSidebarAction, logoutUser, setGoScrollTop, setMoveFloatingButton } from 'Actions';
import { WithRouter } from 'Util/WithRouter';
import { Location } from 'Util/Location';
import CommonPopup from 'Components/Popup/CommonPopup';
import CommonDialog from 'Components/Popup/CommonDialog';
import NotificationSidebar from 'Components/NotificationSidebar';
import CustomerSupportChatButton from './CustomerSupportChatButton';
import { isVietnam } from 'Util/DataUtils';
class MainApp extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
  }

  state = {
    bottom: 20,
    right: 20,
    nowDrag: false,
    isClick: true,
    dragStartX: 0,
    dragStartY: 0,
  };

  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }

  componentDidMount() {
    const customerSupportChatButtonLocation = JSON.parse(localStorage.getItem('customerSupportChatButton'));
    if (customerSupportChatButtonLocation) {
      const { bottom, right } = customerSupportChatButtonLocation;
      this.setState({ bottom, right });
    }
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    const data = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
    if (window.innerWidth < this.state.right || window.innerHeight < this.state.bottom) {
      data.right = 20;
      data.bottom = 20;
    }
    this.setState(data);
  };

  componentDidUpdate(prevProps) {
    const { user, location, navigate } = this.props;
    if (location.pathname !== prevProps.location.pathname) {
      if (user) {
        checkPermission(user, location.pathname, navigate);
      }
      window.scrollTo(0, 0);
    }
    this._moveFloatingButton();
  }

  _goScrollTop() {
    const { goScrollTop, setGoScrollTop } = this.props;
    if (goScrollTop) {
      const scroll = this.scrollRef.current;
      scroll.scrollToTop();
      setGoScrollTop(false);
    }
  }

  _moveFloatingButton() {
    const { moveFloatingButton, setMoveFloatingButton } = this.props;
    if (moveFloatingButton) {
      const { bottom, right } = moveFloatingButton;
      this.setState({ bottom, right });
      setMoveFloatingButton(false);
    }
  }

  renderPage() {
    const { children, isGetLoading } = this.props;
    return (
      <>
        <Scrollbars
          className='rct-scroll'
          autoHide
          autoHideDuration={100}
          onUpdate={() => {
            this._goScrollTop();
          }}
          style={this.getScrollBarStyle()}
          ref={this.scrollRef}
        >
          <div className='rct-page-content'>{children}</div>
        </Scrollbars>
        <LoadingView isLoading={isGetLoading} />
      </>
    );
  }

  //render Sidebar
  renderSidebar() {
    return <SidebarContent />;
  }

  //Scrollbar height
  getScrollBarStyle() {
    return {
      height: 'calc(var(--vh, 1vh) * 100 - 51px)',
    };
  }

  render() {
    const { isLoading, popupData, dialogData, user } = this.props;
    return (
      <div className='app'>
        <Header />
        <div
          className='app-main-container crm-layout'
          onMouseMove={e => {
            if (this.state.nowDrag) {
              const windowWidth = document.documentElement.offsetWidth;
              const windowHeight = document.documentElement.offsetHeight;
              const buttonSize = 50; // 버튼 크기 (32px + 여백)
              const dragThreshold = 10; // 드래그 민감도 (픽셀)

              // 드래그 시작점에서의 거리 계산
              const deltaX = Math.abs(e.clientX - this.state.dragStartX);
              const deltaY = Math.abs(e.clientY - this.state.dragStartY);
              const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

              // 임계값보다 작은 움직임은 무시
              if (distance < dragThreshold) {
                return;
              }

              // 마우스 위치가 창 경계를 벗어나면 초기값으로 리셋
              if (e.clientX < 0 || e.clientY < 0 || e.clientX > windowWidth || e.clientY > windowHeight) {
                const resetPosition = { bottom: 20, right: 20 };
                this.setState({
                  ...resetPosition,
                  isClick: false,
                  nowDrag: false,
                });
                localStorage.setItem('customerSupportChatButton', JSON.stringify(resetPosition));
                return;
              }

              const calculatedRight = windowWidth - e.clientX - 25;
              const calculatedBottom = windowHeight - e.clientY - 25;

              // 계산된 위치가 유효한 범위 내에 있는지 확인
              if (calculatedRight >= 0 && calculatedRight <= windowWidth - buttonSize && calculatedBottom >= 0 && calculatedBottom <= windowHeight - buttonSize) {
                this.setState({
                  bottom: calculatedBottom,
                  right: calculatedRight,
                  isClick: false,
                });
              } else {
                // 유효하지 않은 위치면 초기값으로 리셋
                const resetPosition = { bottom: 20, right: 20 };
                this.setState({
                  ...resetPosition,
                  isClick: false,
                  nowDrag: false,
                });
                localStorage.setItem('customerSupportChatButton', JSON.stringify(resetPosition));
              }
            }
          }}
        >
          <SidebarContent />
          <FieldSidebar />
          <div className='app-container'>
            <div className='rct-app-content'>
              <div className='rct-page'>{this.renderPage()}</div>
            </div>
          </div>
          <NotificationSidebar />
          {!isVietnam(user) && (
            <CustomerSupportChatButton
              bottom={this.state.bottom}
              right={this.state.right}
              onMouseUp={() => this.setState({ nowDrag: false })}
              onMouseDown={e =>
                this.setState({
                  nowDrag: true,
                  isClick: true,
                  dragStartX: e.clientX,
                  dragStartY: e.clientY,
                })
              }
              onClick={() => {
                if (this.state.isClick) {
                  const width = Math.min(480, window.outerWidth * 0.8);
                  const height = window.outerHeight * 0.8;
                  const left = window.screenX + (window.outerWidth - width) / 2;
                  const top = window.screenY + (window.outerHeight - height) / 2;
                  window.open(
                    '/customer-support-chat',
                    'CustomerSupportChat',
                    `toolbar=no,scrollbars=yes,resizable=no,status=no,menubar=no,width=${width}px,height=${height}px,top=${top}px,left=${left}px,directories=no`
                  );
                } else {
                  localStorage.setItem('customerSupportChatButton', JSON.stringify({ bottom: this.state.bottom, right: this.state.right }));
                }
              }}
            />
          )}
        </div>
        <LoadingView isLoading={isLoading} />
        <CommonPopup {...popupData} />
        <CommonDialog {...dialogData} />
      </div>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, settings, loading, scroll, floatingButton }) => {
  const { user } = authUser;
  const { goScrollTop } = scroll;
  const { moveFloatingButton } = floatingButton;
  return { user, ...settings, ...loading, goScrollTop, moveFloatingButton };
};

export default connect(mapStateToProps, {
  collapsedSidebarAction,
  setGoScrollTop,
  logoutUser,
  setMoveFloatingButton,
})(Location(WithRouter(MainApp)));
